/**
 * AxLabs Physics Experiments - Generated Exports
 *
 * All generated physics experiments exported as arrays.
 */
// Mechanics experiments
export { AtwoodMachine, DoubleAtwoodMachine, InclinedPlaneFriction, ElasticCollision1D, InelasticCollision1D, Collision2D, PulleyWithFriction, InclineHangingMass, BlockOnMovingSurface, BankedCurveMotion, } from './mechanics.js';
// Oscillations experiments
export { UnderdampedOscillator, CriticallyDampedOscillator, OverdampedOscillator, ForcedOscillation, CoupledPendulums, CoupledSpringMass, TorsionalPendulum, PhysicalPendulum, } from './oscillations.js';
// Waves experiments
export { StandingWavesString, SoundWaveInterference, DopplerMovingSource, DopplerMovingObserver, BeatFrequency, WaveSuperposition, } from './waves.js';
// Thermodynamics experiments
export { IdealGasIsothermal, IdealGasAdiabatic, IdealGasIsobaric, IdealGasIsochoric, CarnotCycle, HeatConduction1D, } from './thermodynamics.js';
// Optics experiments
export { SnellsLawRefraction, TotalInternalReflection, ThinConvergingLens, ThinDivergingLens, ConcaveMirror, ConvexMirror, DoubleSlitInterference, SingleSlitDiffraction, DiffractionGrating, MalusLawPolarization, } from './optics.js';
// Electromagnetism experiments
export { CoulombsLaw, ElectricFieldPointCharge, ParallelPlateCapacitor, RLCircuitTransient, RLCSeriesResonance, RLCParallelResonance, MagneticForceWire, FaradayLaw, IdealTransformer, LCOscillations, } from './electromagnetism.js';
// Modern physics experiments
export { PhotoelectricEffect, ComptonScattering, BlackbodyRadiation, BohrModel, RadioactiveDecay, RadioactiveDecayChain, } from './modern-physics.js';
// ============================================================================
// EXPERIMENT ARRAYS BY CATEGORY
// ============================================================================
import { AtwoodMachine, DoubleAtwoodMachine, InclinedPlaneFriction, ElasticCollision1D, InelasticCollision1D, Collision2D, PulleyWithFriction, InclineHangingMass, BlockOnMovingSurface, BankedCurveMotion, } from './mechanics.js';
import { UnderdampedOscillator, CriticallyDampedOscillator, OverdampedOscillator, ForcedOscillation, CoupledPendulums, CoupledSpringMass, TorsionalPendulum, PhysicalPendulum, } from './oscillations.js';
import { StandingWavesString, SoundWaveInterference, DopplerMovingSource, DopplerMovingObserver, BeatFrequency, WaveSuperposition, } from './waves.js';
import { IdealGasIsothermal, IdealGasAdiabatic, IdealGasIsobaric, IdealGasIsochoric, CarnotCycle, HeatConduction1D, } from './thermodynamics.js';
import { SnellsLawRefraction, TotalInternalReflection, ThinConvergingLens, ThinDivergingLens, ConcaveMirror, ConvexMirror, DoubleSlitInterference, SingleSlitDiffraction, DiffractionGrating, MalusLawPolarization, } from './optics.js';
import { CoulombsLaw, ElectricFieldPointCharge, ParallelPlateCapacitor, RLCircuitTransient, RLCSeriesResonance, RLCParallelResonance, MagneticForceWire, FaradayLaw, IdealTransformer, LCOscillations, } from './electromagnetism.js';
import { PhotoelectricEffect, ComptonScattering, BlackbodyRadiation, BohrModel, RadioactiveDecay, RadioactiveDecayChain, } from './modern-physics.js';
/**
 * All mechanics experiments
 */
export const mechanicsExperiments = [
    AtwoodMachine,
    DoubleAtwoodMachine,
    InclinedPlaneFriction,
    ElasticCollision1D,
    InelasticCollision1D,
    Collision2D,
    PulleyWithFriction,
    InclineHangingMass,
    BlockOnMovingSurface,
    BankedCurveMotion,
];
/**
 * All oscillation experiments
 */
export const oscillationsExperiments = [
    UnderdampedOscillator,
    CriticallyDampedOscillator,
    OverdampedOscillator,
    ForcedOscillation,
    CoupledPendulums,
    CoupledSpringMass,
    TorsionalPendulum,
    PhysicalPendulum,
];
/**
 * All wave experiments
 */
export const wavesExperiments = [
    StandingWavesString,
    SoundWaveInterference,
    DopplerMovingSource,
    DopplerMovingObserver,
    BeatFrequency,
    WaveSuperposition,
];
/**
 * All thermodynamics experiments
 */
export const thermodynamicsExperiments = [
    IdealGasIsothermal,
    IdealGasAdiabatic,
    IdealGasIsobaric,
    IdealGasIsochoric,
    CarnotCycle,
    HeatConduction1D,
];
/**
 * All optics experiments
 */
export const opticsExperiments = [
    SnellsLawRefraction,
    TotalInternalReflection,
    ThinConvergingLens,
    ThinDivergingLens,
    ConcaveMirror,
    ConvexMirror,
    DoubleSlitInterference,
    SingleSlitDiffraction,
    DiffractionGrating,
    MalusLawPolarization,
];
/**
 * All electromagnetism experiments
 */
export const electromagnetismExperiments = [
    CoulombsLaw,
    ElectricFieldPointCharge,
    ParallelPlateCapacitor,
    RLCircuitTransient,
    RLCSeriesResonance,
    RLCParallelResonance,
    MagneticForceWire,
    FaradayLaw,
    IdealTransformer,
    LCOscillations,
];
/**
 * All modern physics experiments
 */
export const modernPhysicsExperiments = [
    PhotoelectricEffect,
    ComptonScattering,
    BlackbodyRadiation,
    BohrModel,
    RadioactiveDecay,
    RadioactiveDecayChain,
];
/**
 * All generated physics experiments
 */
export const allPhysicsExperiments = [
    ...mechanicsExperiments,
    ...oscillationsExperiments,
    ...wavesExperiments,
    ...thermodynamicsExperiments,
    ...opticsExperiments,
    ...electromagnetismExperiments,
    ...modernPhysicsExperiments,
];
/**
 * Total count of generated experiments
 */
export const experimentCount = {
    mechanics: mechanicsExperiments.length,
    oscillations: oscillationsExperiments.length,
    waves: wavesExperiments.length,
    thermodynamics: thermodynamicsExperiments.length,
    optics: opticsExperiments.length,
    electromagnetism: electromagnetismExperiments.length,
    modernPhysics: modernPhysicsExperiments.length,
    total: allPhysicsExperiments.length,
};
//# sourceMappingURL=index.js.map